import { render } from "./DetailsPageLayout.vue?vue&type=template&id=497f2eaf"
import script from "./DetailsPageLayout.vue?vue&type=script&lang=js"
export * from "./DetailsPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Layout/DetailsPageLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "497f2eaf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('497f2eaf', __exports__)) {
    console.log('reload')
    api.reload('497f2eaf', __exports__)
  }
  
  module.hot.accept("./DetailsPageLayout.vue?vue&type=template&id=497f2eaf", () => {
    console.log('re-render')
    api.rerender('497f2eaf', render)
  })

}


export default __exports__